import { NetworkRequestOptions } from '../../../core/interfaces/request';
import { AppConfig } from '../../../core/app.config';
import { courier } from '../../../core/services/courier.service';
import { FireboltTableTypeEnum } from '../interfaces/interface';

const appConfig = new AppConfig();

export const MapperService = {
  mapperUrl: appConfig.getMapperURL(),

  buildCreateTableParams(
    integrationId: number,
    schemaName: string,
    fields: any[],
    partitionStyle?: any,
    partitionType?: any,
    tableType?: FireboltTableTypeEnum
  ) {
    return {
      integration_id: integrationId,
      schema_name: schemaName,
      fields,
      metadata: {
        partition: {
          partition_style: partitionStyle?.value,
          partition_type: partitionType
        },
        table_type: tableType
      }
    };
  },

  createTable(
    integrationId: number,
    destinationId: any,
    schemaName: string,
    fields: any[],
    partitionStyle?: any,
    partitionType?: any,
    tableType?: FireboltTableTypeEnum,
    showErrorMessage = true
  ) {
    const params = this.buildCreateTableParams(
      integrationId,
      schemaName,
      fields,
      partitionStyle,
      partitionType,
      tableType
    );

    const requestUrl = `${this.mapperUrl}/${destinationId}/create-schema`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showLoading: false,
        showSuccessMsg: false,
        showErrorMsg: showErrorMessage
      }
    };

    return courier.post(requestUrl, options, params);
  },

  getCreateTableQuery(
    integrationId: number,
    destinationId: any,
    schemaName: string,
    fields: any[],
    partitionStyle?: any,
    partitionType?: any,
    tableType?: FireboltTableTypeEnum
  ) {
    const params = this.buildCreateTableParams(
      integrationId,
      schemaName,
      fields,
      partitionStyle,
      partitionType,
      tableType
    );

    const requestUrl = `${this.mapperUrl}/${destinationId}/get-create-schema-query`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showLoading: false,
        showSuccessMsg: false
      }
    };

    return courier.post(requestUrl, options, params);
  },

  updateMapping(
    integrationId: any,
    mappingId: any,
    params: any,
    validateMappingEnabled = true
  ): Promise<any> {
    const requestUrl = `${this.mapperUrl}/${integrationId}/schema_mapping/${mappingId}`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showLoading: false
      }
    };

    return courier.put(requestUrl, options, {
      ...params,
      validate_mapping_enabled: validateMappingEnabled
    });
  }
};
